<template>
    <header class="topbar">
        <div class="topbar-left">
            <span class="topbar-btn sidebar-toggler"><i>&#9776;</i></span>
        </div>
        <div class="topbar-center logo-icon">
            <div class="text-center">
                <img class="mb-10 logo-fitila" src="../../assets/static/fitila.png" alt="logo icon">
            </div>
        </div>

        <div class="topbar-right">
            <ul class="topbar-btns">
                <li class="dropdown">
                    <span class="topbar-btn" data-toggle="dropdown">
                        <img class="avatar avatar-lg" v-if="userDetails.avatar == null" src="../../assets/static/img/avatar.jpg">
                        <img class="avatar avatar-lg" v-else :src="userDetails.avatars[0].secure_url">
                    </span>
                    <div class="dropdown-menu dropdown-menu-right">
                        <router-link tag="a" to="/listener/profile" class="dropdown-item">
                            <i class="ion-home"></i>View Profile
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <router-link tag="a" to="/home" class="dropdown-item">
                            <i class="ion-arrow-swap"></i>Switch Profile
                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
    </header>

</template>

<script>
import axios from 'axios'
import allMixins from '../../mixins.js'

export default {
    mixins: [allMixins],
    data() {
        return {
        loading: true,
        userDetails: {}
        }
    },
    methods: {
    },
    mounted() {
    let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
    axios.get(`users/find/${details.id}`)
    .then(res => {
        this.userDetails = res.data.listener[0]
        this.loading = false
    })
    .catch(err => {
          this.loading = false
          this.$notify({
          group: 'response',
          type: 'error',
          text: 'Error fetching user. Log in again',
          duration: 2500,
        });
        setTimeout(() => {
            this.$router.push('/')
          }, 3000)
    })
  }
}
</script>